import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import BalanceMargin from './BalanceMargin'
import BalanceExChange from './BalanceExChange'
import { APPNAME } from 'app/constants/APIKEYS'
import BalanceGroup from './BalanceGroup'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminBalancePage = () => {
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '정산현황',
			link: '/balance/all',
		},
		{
			title: '그룹별정산',
			link: '/balance/group',
		},
		{
			title: '일일정산',
			link: '/balance/daily',
		},
	]

	const renderContent = () => {
		switch (url) {
			case '/balance':
			case '/balance/all':
				return <BalanceExChange title={'정산현황'} />
			case '/balance/group':
				return <BalanceGroup title={'그룹별정산현황'} />
			case '/balance/daily':
				return <BalanceMargin title={'일일정산'} />
			default:
				return <BalanceExChange title={'정산현황'} />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>{APPNAME + " ADMIN - 정산관리"}</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
